/* eslint-disable max-len */
// @flow
import { combineReducers } from 'redux';
import { AsyncRequest } from 'angieslist-app-platform';
import { get } from 'lodash';
import { isAngiLeadsPermission } from 'angieslist-office-app-common/lib/util/angiLeadsUtils';
import actionKeys from './userActionKeys';
import type { AsyncState } from '../../types';
import type { UserInfo } from './userService';
import serviceProviderActions from '../../common/serviceProvider/serviceProviderActions';

export type UserState = {
  userInfo: AsyncState<void, UserInfo>;
}

export default (combineReducers({
  userInfo: AsyncRequest.createReducer(actionKeys.GET_USER, {
    [actionKeys.GET_USER_SUCCESS]: (state, action) => {
      const entitlements = get(action.payload.body, 'entitlements', []);
      const maybeAngiLeadsEntitlement = entitlements.filter(entitlement => isAngiLeadsPermission(entitlement.permission));
      maybeAngiLeadsEntitlement.forEach((element) => {
        const maybeAngiLeadsScopeId = get(element, 'scopeId');
        if (maybeAngiLeadsScopeId) {
          action.addSideEffect((store) => {
            store.dispatch(serviceProviderActions.addAngiLeadsProToServiceProviderCache(maybeAngiLeadsScopeId));
          });
        }
      });
      return AsyncRequest.setSuccess(state, action.payload.body);
    },
  }),
}): any);



// WEBPACK FOOTER //
// ./src/app/common/user/userReducer.js